<template>
	<div class="main partner">
		<Header></Header>
		<div class="content">

			<div class="box">
				<cardHead title="圈舍分析"></cardHead>
				<div class="box-content">
					<div class="box-item" v-for='(item,index) in foldData'>
						<el-dropdown style='color:#00FEFF;margin:0.25rem;cursor: pointer;' trigger="click">
							<span class="el-dropdown-link">
								{{item.name}}<i class="el-icon-caret-bottom el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown" >
								<el-dropdown-item >养殖圈舍1号</el-dropdown-item>
								<el-dropdown-item >养殖圈舍2号</el-dropdown-item>
								<el-dropdown-item >养殖圈舍3号</el-dropdown-item>

							</el-dropdown-menu>
						</el-dropdown>
						<div class="statistic">
							<div class="statistic-tab">
								<div class="statistic-name">
									现有羊只总数：
								</div>
								<div class="statistic-val">
									{{item.num}}
								</div>
							</div>
							<div class="statistic-tab">
								<div class="statistic-name">
									异常羊只总数：
								</div>
								<div class="statistic-val">
									0
								</div>
								<img src="@/assets/yq/arrow.png" class="icon" alt="">
							</div>
							<div class="statistic-tab">
								<div class="statistic-name">
									饮水槽：
								</div>
								<div class="statistic-val">
									{{item.trough}}/ <span class="statistic-unit">{{item.temperature}}℃</span>
								</div>
							</div>

						</div>
						<div class="fold-status">
							<div class="status-item">
								<img class="status-img" v-if='item.status==3' src="@/assets/yq/fold/excellent.png"
									alt="">
								<img class="status-img" v-if='item.status==2' src="@/assets/yq/fold/good.png" alt="">
								<img class="status-img" v-if='item.status==1' src="@/assets/yq/fold/bad.png" alt="">
							</div>
							<div class="status-item">
								<div class="item-val">
									{{item.nh3}}
								</div>
								<div class="item-name">
									<img class="icon" src="@/assets/yq/fold/icon7.png" alt="">
									<span class="label">氨气含量</span>
									<span class="unit">mg/m³</span>
								</div>
							</div>
							<div class="status-item">
								<div class="item-val">
									{{item.pm2}}
								</div>
								<div class="item-name">
									<img class="icon" src="@/assets/yq/fold/icon8.png" alt="">
									<span class="label">PM2.5</span>
									<span class="unit">μg/m³</span>
								</div>
							</div>
						</div>
						<div class="lineChart" :id="'lineChart'+index"></div>
						<div class="panels">
							<div class="panel-warp">
								<div class="panel">
									<div class="panel-top">
										<span class="panel-name">温度</span>
										<img src="@/assets/yq/fold/icon1.png" class="icon" alt="">
									</div>
									<div class="panel-mid">
										<span class="panel-val">{{item.statData.temperature.val}}</span>
										<span class="panel-unit">℃</span>
									</div>
									<div class="panel-bottom">
										<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
										<span class="panel-staus"
											:class='getStatus(item.statData.temperature)'>适中</span>

									</div>
								</div>
								<img src="@/assets/yq/fold/line.png" alt="" class="line">
								<div class="panel">
									<div class="panel-top">
										<span class="panel-name">湿度</span>
										<img src="@/assets/yq/fold/icon2.png" class="icon" alt="">
									</div>
									<div class="panel-mid">
										<span class="panel-val">{{item.statData.rm.val}}</span>
										<span class="panel-unit">/rm</span>
									</div>
									<div class="panel-bottom">
										<span class="panel-staus" :class='getStatus(item.statData.rm)'>适中</span>
									</div>
								</div>
								<img src="@/assets/yq/fold/line.png" alt="" class="line">
								<div class="panel">
									<div class="panel-top">
										<span class="panel-name">气压</span>
										<img src="@/assets/yq/fold/icon3.png" class="icon" alt="">
									</div>
									<div class="panel-mid">
										<span class="panel-val">{{item.statData.kpa.val}}</span>
										<span class="panel-unit">kpa</span>
									</div>
									<div class="panel-bottom">
										<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
										<span class="panel-staus" :class='getStatus(item.statData.kpa)'>适中</span>

									</div>
								</div>
							</div>
							<img src="@/assets/yq/fold/line2.png" class="line" alt="">
							<div class="panel-warp">
								<div class="panel">
									<div class="panel-top">
										<span class="panel-name">硫化氢</span>
										<img src="@/assets/yq/fold/icon4.png" class="icon" alt="">
									</div>
									<div class="panel-mid">
										<span class="panel-val">{{item.statData.h2s.val}}</span>
										<span class="panel-unit">mg/m³</span>
									</div>
									<div class="panel-bottom">
										<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
										<span class="panel-staus"
											:class='getStatus(item.statData.h2s)'>{{item.statData.h2s.name}}</span>

									</div>
								</div>
								<img src="@/assets/yq/fold/line.png" alt="" class="line">
								<div class="panel">
									<div class="panel-top">
										<span class="panel-name">氮气</span>
										<img src="@/assets/yq/fold/icon5.png" class="icon" alt="">
									</div>
									<div class="panel-mid">
										<span class="panel-val">{{item.statData.n2.val}}</span>
										<span class="panel-unit">%</span>
									</div>
									<div class="panel-bottom">
										<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
										<span class="panel-staus" :class='getStatus(item.statData.n2)'>适中</span>

									</div>
								</div>
								<img src="@/assets/yq/fold/line.png" alt="" class="line">
								<div class="panel">
									<div class="panel-top">
										<span class="panel-name">二氧化碳</span>
										<img src="@/assets/yq/fold/icon6.png" class="icon" alt="">
									</div>
									<div class="panel-mid">
										<span class="panel-val">{{item.statData.co2.val}}</span>
										<span class="panel-unit">mg/m³</span>
									</div>
									<div class="panel-bottom">
										<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
										<span class="panel-staus"
											:class='getStatus(item.statData.co2)'>{{item.statData.co2.name}}</span>

									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import cardHead from "./components/cardHead.vue";

	import Header from "@/views/yqScreen/components/header.vue";


	export default {
		components: {
			cardHead,
			Header
		},
		data() {
			return {
				day1: [
					{
						title: '氨气含量',
						month: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00',
							'09:00'
						],
						value: [2, 6, 8, 5, 1, 3,7, 9, 5, 6]
					},
				],
				day2: [
					{
						title: '氨气含量',
						month: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00',
							'09:00'
						],
						value: [6, 16, 10, 13, 19, 5,17, 19, 15, 16]
					},
				],
				day3: [
					{
						title: '氨气含量',
						month: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00',
							'09:00'
						],
						value: [12, 6, 28, 35, 28, 23,37, 32, 29, 36]
					},
				],
				nh3: ['1', '2', '3'],
				foldData: [{
						name: '养殖圈舍1号',
						num: 150,
						trough: 2,
						temperature: 30,
						status: 3,
						nh3: 1,
						pm2: 85,

						statData: {
							temperature: {
								val: '14.0',
								name: '适中',
								status: 3,


							},
							rm: {
								val: '55',
								name: '适中',
								status: 3


							},
							kpa: {
								val: '85.50',
								name: '适中',
								status: 3

							},
							h2s: {
								val: '2',
								name: '优秀',
								status: 3

							},
							n2: {
								val: '78',
								name: '适中',
								status: 3

							},
							co2: {
								val: '500',
								name: '优秀',
								status: 3

							},


						}


					},
					{
						name: '养殖圈舍2号',
						num: 145,
						trough: 2,
						temperature: 30.5,
						status: 2,
						nh3: 13,
						pm2: 91,

						statData: {
							temperature: {
								val: '14.2',
								name: '适中',
								status: 3

							},
							rm: {
								val: '58',
								name: '适中',
								status: 3

							},
							kpa: {
								val: '85.48',
								name: '适中',
								status: 3

							},
							h2s: {
								val: '4',
								name: '良好',
								status: 2

							},
							n2: {
								val: '78',
								name: '适中',
								status: 3

							},
							co2: {
								val: '960',
								name: '良好',
								status: 2

							},


						}


					}, {
						name: '养殖圈舍3号',
						num: 160,
						trough: 2,
						temperature: 30.2,
						status: 1,
						nh3: 32,
						pm2: 140,

						statData: {
							temperature: {
								val: '13.8',
								name: '适中',
								status: 3

							},
							rm: {
								val: '60',
								name: '适中',
								status: 3

							},
							kpa: {
								val: '85.50',
								name: '适中',
								status: 3

							},
							h2s: {
								val: '20',
								name: '较差',
								status: 1

							},
							n2: {
								val: '78',
								name: '适中',
								status: 3

							},
							co2: {
								val: '1600',
								name: '较差',
								status: 1

							},


						}


					}



				]

			};
		},
		watch: {},
		created() {

		},
		mounted() {
			this.setLineData(this.day1, 'lineChart0', 0)
			this.setLineData(this.day2, 'lineChart1', 1)
			this.setLineData(this.day3, 'lineChart2', 2)
		},
		update() {

		},
		methods: {
			getStatus(item) {
				console.log(item)
				console.log(item.status)
				if (item.status == 1) {
					return 'bad'
				}
				if (item.status == 2) {
					return 'good'
				}
				if (item.status == 3) {
					return 'excellent'
				}

			},
			setLineData(data, dom, index) {
				const colors = ['#00FEFF', '#FFF200', '#40FF00'];
				const legend = [];
				const series = [];
				let xAxis = [];

				data.forEach((item, index) => {

					xAxis = item.month
					series.push({
						name: item.title,
						type: "line",
						smooth: true,
						showSymbol: false,
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: 'rgba(0,246,236,0.48)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(91,233,255,0)' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						},
						lineStyle: {
							width: 2,
						},
						color: colors[index],
						data: item.value,
					})
				})
				const line = {
					dom,
					xAxis,
					legend: {
						data: legend,
						// x: 'right',
						// y: 'top',
						top: "0%",
						right: "3%",
						itemWidth: 8,
						itemHeight: 8,
						padding: [10, 0, 0, 0],
					},
					series: series
				}
				this.lineChart(line, index)
			},
			lineChart(data, index) {
				this.chart = this.$echarts.init(document.getElementById(data.dom))
				// 隐藏动画加载效果。

				var option = {
					color: ['#FFF200', '#00FEFF', '#FFF200'],
					tooltip: {
						trigger: 'axis',
						padding: [5, 20],
						backgroundColor: 'rgba(255,255,255,0.8)',
						// borderColor: 'rgba(18, 36, 132, 1)',
						borderColor: '#292929',
						borderWidth: 1,
						textStyle: {
							color: '#050F37',
						},
						formatter: (e) => {
							this.foldData[index].nh3 = e[0].data
							// this.nh3[index] = e[0].data
							// console.log(this.nh3)
							this.$forceUpdate()


						}
					},
					legend: data.legend,
					grid: {
						top: '20%',
						left: '5%',
						right: '4%',
						bottom: '10%',
						containLabel: true,
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,

						axisLabel: {
							color: '#00FEFF',
							fontSize: '0.13rem',
						},
						axisLine: {

							show: true, // X轴 网格线 颜色类型的修改
							// symbolSize: [10, 15],
							symbolOffset: [0, 0],
							lineStyle: {
								color: '#5BE9FF',
								type: 'solid',
							},
						},
						axisTick: {
							// X轴线 刻度线
							show: true,
							inside: true,
							alignWithLabel: false
						},
						axisPointer: {
							lineStyle: {
								color: '#00F6EC',
								type: 'solid'
							},
							value: 8,
							snap: true,
							handle: {
								show: true
							}
						},
						data: data.xAxis,
					},
					yAxis: {
						name: 'mg/m³',
						nameTextStyle: {
							color: '#00FEFF',
							padding: [3, 30, 0, 0],
							fontSize: '0.1rem',
						},
						// max: 320,
						scale: false,
						type: 'value',
						splitNumber: 5,

						axisLine: {
							// symbol: ['none', 'arrow'],
							// show: true, // X轴 网格线 颜色类型的修改
							// // symbolSize: [10, 15],
							// symbolOffset: [0, 12],
							// lineStyle: {
							// 	color: 'rgba(255,0,0,1)',
							// 	type: 'solid',
							// },
						},
						splitLine: {
							lineStyle: {
								type: 'soild',
								color: 'rgba(0,246,236,0.2)'
							}
						},
						axisLabel: {

							color: '#00FEFF',
							fontSize: '0.15rem',
						},
					},
					series: data.series,
				}
				this.chart.clear();
				this.chart.setOption(option)
				window.addEventListener('resize', () => {
					this.chart.resize()
				})
			},
		},
	};
</script>
<style lang="scss" scoped>
	.main {
		width: 24rem;
		// height: 13.5rem;
		min-height: 100vh;
		margin: 0 auto;
		background: url('../../../assets/yq/animal-bg.png');
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;

		.head {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 1.2rem;
			background: url('../../../assets/yq/headbg.png');
			background-size: 100% 100%;
			font-size: 0.55rem;
			font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
			font-weight: 700;
			color: #19ECFF;
			letter-spacing: 5px;
		}


		.gobcak {
			width: .875rem;
			height: .4375rem;
			position: absolute;
			z-index: 99;
			bottom: -0.25rem;
			left: 0.25rem;
			font-size: .2rem;
			font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
			font-weight: 400;
			color: #00E0DB;
			display: flex;
			align-items: center;
			cursor: pointer;

			img {
				width: .3rem;
				height: .3rem;
			}

			span {
				margin-left: .05rem;
			}
		}


		.content {
			padding: .41rem 0.39rem;
			box-sizing: border-box;
			display: flex;
			flex: 1;
			flex-direction: column;
			// min-height: 12.5rem;
			// min-height: calc(100vh - 1rem);
			position: relative;

			.box {
				width: 100%;
				display: flex;
				flex-direction: column;
				flex: 1;
				background: url('../../../assets/yq/fold/rectangle1.png');

				// background-position: ;
				.box-content {
					flex: 1;
					padding: 0 0.29rem;
					padding-bottom: 0.25rem;
					display: flex;
					justify-content: space-between;

					.box-item {
						width: 7.38rem;
						height: 10.35rem;
						background: url('../../../assets/yq/fold/rectangle2.png');
					}
				}

			}
		}

		.video_box {
			position: relative;
			// width: 7.63rem;
			width: 5.75rem;
			height: 4rem;
			padding: .2rem;
			margin: .25rem;
			// border: 0.01rem solid rgba(0, 224, 219, 0.08);
			z-index: 100;

			.top_box {
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 1rem;

				&::after {
					position: absolute;
					left: 0;
					bottom: 0;
					content: "";
					width: .18rem;
					height: .14rem;
					border-left: 1px solid #00E0DB;
					;
					border-bottom: 1px solid #00E0DB;
					;

				}

				&::before {
					position: absolute;
					right: 0;
					bottom: 0;
					content: "";
					width: .18rem;
					height: .14rem;
					border-right: 1px solid #00E0DB;
					;
					border-bottom: 1px solid #00E0DB;
					;

				}
			}
		}

		.server {
			width: 5.74rem;
			height: 0.44rem;
			background: rgba(25, 236, 255, 0.06);
			border-radius: 0.05rem 0.05rem 0rem 0rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tag {
				display: flex;
				align-items: center;

				img {
					margin-left: .16rem;
				}
			}

			// padding-top: .24rem;
			.card_ {
				font-size: 0.23rem;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				padding-left: .25rem;
			}

			.date {
				// margin-left: 1.2rem;
				color: #7B8A89;
				padding-right: 0.15rem;

				span {
					padding: .03rem .05rem;
					border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
					font-size: 0.13rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					background: rgba(255, 255, 255, 0.05);
					opacity: .5;
					font-weight: 400;
					cursor: pointer;
				}

				span:nth-child(2) {
					margin: 0 .13rem;
				}
			}
		}

		.active {
			background: rgba(255, 255, 255, 0.2) !important;
			// opacity: 1;
			color: #00E0DB !important;
			opacity: 1 !important;
		}

		.sport {
			display: flex;
			flex-direction: column;
			font-size: 0.38rem;
			font-family: Source Han Sans CN-Bold, Source Han Sans CN;
			font-weight: bold;
			color: #00E0DB;
			margin-top: .44rem;
			margin-left: .5rem;

			span:nth-child(2) {
				font-size: 0.15rem;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
				margin-top: .2rem;
			}
		}

		@keyframes warn {
			0% {
				transform: scale(0);
				opacity: 0.0;
			}

			25% {
				transform: scale(0);
				opacity: 0.45;
			}

			50% {
				transform: scale(0.1);
				opacity: 0.65;
			}

			75% {
				transform: scale(0.5);
				opacity: 0.85;
			}

			100% {
				transform: scale(1);
				opacity: 0.0;
			}
		}

		.big_box {
			position: absolute;
			width: 0.24rem;
			height: 0.24rem;
			// background: rgba(0, 255, 255, 0);
			// opacity: 1;
			border: 0.1rem solid rgba(255, 255, 255, 1);
			border-radius: 50%;
			-webkit-border-radius: 50%;
			-moz-border-radius: 50%;
			z-index: 1;
			opacity: 0;
			-webkit-animation: warn 3s ease-out;
			-moz-animation: warn 3s ease-out;
			animation: warn 3s ease-out;
			-webkit-animation-iteration-count: infinite;
			-moz-animation-iteration-count: infinite;
			animation-iteration-count: infinite;

			.center_box1 {
				width: 0.16rem;
				height: 0.16rem;
				// background: rgba(0, 255, 255, 0);
				// opacity: 1;
				-webkit-border-radius: 50%;
				-moz-border-radius: 50%;
				z-index: 1;
				opacity: 0;
				-webkit-animation: warn 3s ease-out;
				-moz-animation: warn 3s ease-out;
				animation: warn 3s ease-out;
				-webkit-animation-iteration-count: infinite;
				-moz-animation-iteration-count: infinite;
				animation-iteration-count: infinite;
				border: 0.1rem solid rgba(255, 255, 255, 1);
				border-radius: 50%;
				margin: auto;
				margin-top: .025rem;

				.small_box {
					width: 0.06rem;
					height: 0.06rem;
					background: rgba(255, 255, 255, 1);
					opacity: 0;
					-webkit-animation: warn 3s ease-out;
					-moz-animation: warn 3s ease-out;
					animation: warn 3s ease-out;
					-webkit-animation-iteration-count: infinite;
					-moz-animation-iteration-count: infinite;
					animation-iteration-count: infinite;
					border-radius: 50%;
					padding: .03rem;
					margin: auto;
					margin-top: .03rem;
				}
			}
		}



		.active1 {
			color: #11F3D6 !important;
			opacity: 1 !important;
			z-index: 99999;
		}

		.box_ {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			position: fixed;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, .8);
			z-index: 9999;

		}

		.num_change {
			color: #FFFFFF !important;
		}

		.dialog_ {
			// margin-top: -2.5rem;
			min-width: 15.79rem;
			min-height: 3.77rem;
			position: relative;
			background: url('../../../assets/低.png');
			background-size: 100% 100%;

			.text {
				font-size: 0.3rem;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #032929;
				position: absolute;
				top: 0.3rem;
				left: 7.2rem;
			}

			.close_icon {
				position: absolute;
				top: .25rem;
				right: .38rem;
				color: #00e0db;
				font-size: .3rem;
				cursor: pointer;
			}

			.num {
				font-size: 0.13rem;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
				display: flex;
				justify-content: end;
				margin: 0 .38rem 0.26rem 0;

				span {
					color: #7B8A8A;
					font-size: 0.18rem;
					font-weight: 700;
					margin-left: .21rem;
					cursor: pointer;
				}
			}

		}

		.dialog {
			// margin-top: -2.5rem;
			min-width: 8.79rem;
			min-height: 5.81rem;
			position: relative;
			background: url('../../../assets/info.png');
			background-size: 100% 100%;

			.text {
				font-size: 0.3rem;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #032929;
				position: absolute;
				top: 0.25rem;
				left: 3.8rem;
			}

			.close_icon {
				position: absolute;
				top: .25rem;
				right: .38rem;
				color: #00e0db;
				font-size: .3rem;
				cursor: pointer;
			}

			.picture {
				display: flex;
				margin-top: 1.22rem;
				margin-left: .5rem;

				.p_left {
					width: 3rem;
					height: 4.1rem;

					img {
						width: 100%;
						height: 3rem;
						border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
						cursor: pointer;

					}

					.img {
						display: flex;
						margin-top: .18rem;

						img {
							width: .88rem;
							height: .88rem;
							border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
							cursor: pointer;

						}

						img:nth-child(2) {
							margin: 0 .18rem;
						}
					}
				}

				.p_right {
					flex: 1;
					height: 4.1rem;
					margin-left: .63rem;
					display: flex;
					// justify-content: space-around;

					.info_1 {
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						// align-items: center;
						font-size: 0.2rem;
						font-family: PingFang SC-中等, PingFang SC;
						font-weight: normal;
						color: #0DD3DD;
					}

					.info_ {
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						// align-items: center;
						font-size: 0.2rem;
						font-family: PingFang SC-中等, PingFang SC;
						font-weight: normal;
						color: #FFFFFF;
						margin-left: .34rem;
					}

				}
			}

		}

		.statistic {
			padding: 0.1rem 0.3rem;
			display: flex;
			justify-content: space-between;

			.statistic-tab {
				display: flex;
				align-items: center;

				.statistic-name {
					font-size: 0.18rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					font-weight: 400;
					color: #FFFFFF;
				}

				.statistic-val {
					font-size: 0.33rem;
					font-family: Impact-Regular, Impact;
					font-weight: 400;
					color: #FFF200;
					line-height: 0.5rem;

					.statistic-unit {
						font-family: Impact-Regular, Impact;
						font-weight: 400;
						color: #FFF200;
						font-size: 0.2rem;
					}
				}

				.icon {
					width: 0.31rem;
					height: 0.31rem;
					margin-left: 0.07rem;
				}
			}
		}

		.statistic ::v-deep .number {
			font-size: 0.33rem;
			font-family: Impact-Regular, Impact;
			font-weight: 400;
			color: #FFF200;
			line-height: 0.5rem;
		}

		.fold-status {
			display: flex;
			padding: 0 0.29rem;
			justify-content: space-between;
			align-items: center;
			margin-top: 0.86rem;

			.status-item {
				height: 1.1rem;
				width: 1.88rem;
				display: flex;
				flex-direction: column;
				align-items: center;

				.status-img {
					width: 1.88rem;
					height: 1.1rem;
				}

				.item-val {
					font-size: 0.4rem;
					font-family: DIN-Medium, DIN;
					font-weight: 500;
					color: #00FEFF;
					margin-top: 0.14rem;
					margin-bottom: 0.34rem;
				}

				.item-name {
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 100%;

					.icon {
						width: 0.21rem;
						height: 0.21rem;
					}

					.label {
						font-size: 0.15rem;
						font-family: Source Han Sans CN-Regular, Source Han Sans CN;
						font-weight: 400;
						color: #00FEFF;
					}

					.unit {
						font-size: 0.13rem;
						font-family: Source Han Sans CN-Regular, Source Han Sans CN;
						font-weight: 400;
						color: #00FEFF;
					}
				}
			}
		}

		.lineChart {
			height: 2.62rem;
			width: 100%;
			margin-top: .44rem;
		}

		.panels {
			text-align: center;

			// margin-top: 0.42rem;
			.line {
				display: flex;
				width: 6.68rem;
				height: 0.02rem;
			}

			.panel-warp {
				display: flex;
				justify-content: center;
				margin-top: 0.2rem;
				align-items: center;

				.line {
					width: 0.02rem;
					height: 1.49rem;
					display: flex;
				}

				.panel {
					margin-top: 0.06rem;
					margin-bottom: 0.2rem;
					width: 2.35rem;
					height: 1.49rem;
					margin-left: 0.5rem;

					.panel-top {
						text-align: left;

						.panel-name {
							font-size: 0.18rem;
							font-family: Source Han Sans CN-Regular, Source Han Sans CN;
							font-weight: 400;
							color: #00FEFF;
							margin-right: 0.14rem;
						}

						.icon {
							height: 0.23rem;
						}
					}

					.panel-mid {
						margin-top: 0.31rem;
						text-align: center;

						.panel-val {
							font-size: 0.3rem;
							font-family: Source Han Sans CN-Medium, Source Han Sans CN;
							font-weight: 500;
							color: #00F6EC;
						}

						.panel-unit {
							font-size: 0.13rem;
							font-family: Source Han Sans CN-Regular, Source Han Sans CN;
							font-weight: 400;
							color: #00FEFF;
						}
					}

					.panel-bottom {
						margin-top: 0.15rem;

						.panel-staus {
							box-sizing: content-box;
							width: 0.45rem;
							height: 0.24rem;
							line-height: 0.24rem;
							border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
							font-size: 0.15rem;
							padding: 0.05rem 0.04rem;
							color: #fff;
							display: block;
							text-align: center;
						}
					}
				}
			}
		}

	}
	
	.good {
		background: rgba(255, 161, 0, 0.9);
	}

	.bad {
		background: rgba(255, 34, 0, 0.9);
	}

	.excellent {
		background: rgba(0, 255, 52, 0.6);
	}
</style>